module.exports = __webpack_public_path__ + "static/media/pt-packages.ec80093a.svg";